<template>
    <div class="sim_graf_chart sim_graf_chart-heat">
        <highcharts v-if="insuranceChartOptions !== null" :options="insuranceChartOptions"></highcharts>
        <div class="recharts_legend">
            <div class="recharts_legend_item">
            </div>
            <div class="recharts_legend_item">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InsuranceCoverageChartComponent",
    props: {
        historicalData: null,
        limitsData: null,
        insurancePrice: null,
    },

    mounted() {
        this.prepareChartData();
    },

    data: function () {
        return {
            insuranceChartOptions: null,
        };
    },

    watch: {
        insurancePrice(val) {
            this.prepareChartData();
        }
    },

    computed: {
        chartYears() {
            return Object.keys(this.historicalData);
        },

        heatDaysCount() {
            let heatDaysCount = [];

            for (let chartYear of this.chartYears) {
                let countOfHeatDayPerYear = 0;
                for(let dataItem of this.historicalData[chartYear].data) {
                    if(dataItem.heat >= this.limitsData.HD.threshold) {
                        countOfHeatDayPerYear++;
                    }
                }
                heatDaysCount.push(countOfHeatDayPerYear);
            }
            return heatDaysCount;
        },

        precipitationAmount() {
            let drought = [];

            for (let chartYear of this.chartYears) {
                let droughtSum = 0;
                for(let dataItem of this.historicalData[chartYear].data) {
                    if(dataItem.precipitation >= 2) {
                        droughtSum += parseFloat(dataItem.precipitation);
                    }

                }
                drought.push(droughtSum);
            }
            return drought;
        },

        insurancePricePerYear() {
            let insurancePrice = [];

            for(let yearIndex in this.chartYears) {
                let insurancePricePerYear = 0;

                insurancePricePerYear += this.calculatePrice('heat', this.heatDaysCount[yearIndex]);
                insurancePricePerYear += this.calculatePrice('x_rain', this.precipitationAmount[yearIndex]);
                insurancePricePerYear += this.calculatePrice('drought', this.precipitationAmount[yearIndex]);

                insurancePrice.push(insurancePricePerYear);
            }
            return insurancePrice;
        },
    },

    methods: {
        calculatePrice(key, historicalValue) {
            let result = 0;
            switch (key) {
                case 'heat':
                    if(historicalValue - this.limitsData.HD.value >= 0) {
                        result = ((historicalValue - this.limitsData.HD.value) + 1) * 0.05 * this.insurancePrice;
                    }
                    break;
                case 'x_rain':
                    if(historicalValue - this.limitsData.XR.value >= 0) {
                        result = ((historicalValue - this.limitsData.XR.value) / 10 + 1) * 0.05 * this.insurancePrice;
                    }
                    break;
                case 'drought':
                    if((historicalValue > 2) && (this.limitsData.DR.value - historicalValue >= 0)) {
                        result = (1 - (historicalValue / this.limitsData.DR.value)) * this.insurancePrice;
                    }
                    break;
            }

            return result;
        },

        getStatsByYear(year) {
            let index = this.chartYears.indexOf(year);

            let precipitation = this.precipitationAmount[index];
            let heat = this.heatDaysCount[index];
            return {
                precipitation: precipitation,
                heat: heat,
                x_rain_insurance: this.calculatePrice('x_rain', this.precipitationAmount[index]),
                drought_insurance: this.calculatePrice('drought', this.precipitationAmount[index]),
                heat_insurance: this.calculatePrice('heat', this.heatDaysCount[index]),
            };
        },

        prepareChartData() {
            window.getStatsByYear = this.getStatsByYear;
            this.insuranceChartOptions = {
                chart: {
                    type: 'column',
                    backgroundColor: '#f8f9fa'
                },
                title: {
                    text: '',
                },
                legend:{
                    enabled:false
                },
                tooltip: {
                    formatter: function () {
                        let dataPerYear = window.getStatsByYear(this.x);
                        return `<b>Сезон: ${this.x}</b>` +
                            `<br><p>Злива: ${Number(dataPerYear.precipitation).toFixed(2)} мм <b>${Number(dataPerYear.x_rain_insurance).toFixed(2)}$/Га</b></p>` +
                            `<br><p>Нестача опадів: ${Number(dataPerYear.precipitation).toFixed(2)} мм <b>${Number(dataPerYear.drought_insurance).toFixed(2)}$/Га</b></p>` +
                            `<br><p>Спека: ${Number(dataPerYear.heat).toFixed(0)} днів <b>${Number(dataPerYear.heat_insurance).toFixed(2)}$/Га</b></p>`;
                    },
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            borderWidth: 0,
                            borderColor: '#ffffff',
                            style: {
                                textOutline: "0px",
                                color: '#000000',
                            },
                            formatter: function () {
                                return Number(this.y).toFixed(0);
                            }
                        },
                        borderWidth: 0,
                        stacking: 'normal',
                        pointWidth: 36,
                    }
                },
                xAxis: {
                    gridLineWidth: 1.5,
                    gridLineColor: '#d7d7d7',
                    gridLineDashStyle: 'LongDash',
                    categories: this.chartYears,
                },
                yAxis: [
                    {
                        gridLineWidth: 1.5,
                        gridLineColor: '#d7d7d7',
                        gridLineDashStyle: 'LongDash',
                        title: {
                            text: ''
                        },
                        labels: {
                            format: '{value} $'
                        },
                    }
                ],
                series: [
                    {
                        name: 'insurance',
                        width: 36,
                        color: '#44546A',
                        data: this.insurancePricePerYear,

                    },
                ]
            };
        },
    }
}
</script>

<style scoped>

</style>
